// extracted by mini-css-extract-plugin
export default {"value":"InitForces_value__BUTC8","wrapper":"InitForces_wrapper__n-snA"};